import { useEffect, useState } from "react";
import { Icon } from "@/components/Icon";
import { holdReminder } from "./callHold";

// «Удержание» в окне звонка: кнопка и подсказка. Одни и те же у исходящего
// (CallModal) и у перехваченного входящего (InboundCallModal) — то же окно в
// программе для Windows.

/** «Удержание» / «Вернуться к разговору». Только в живом разговоре — решает
 * вызывающий. */
export function HoldButton({ held, onToggle }: { held: boolean; onToggle: () => void }) {
  return (
    <button
      type="button"
      className={"call-btn " + (held ? "call-btn--call call-hold-resume" : "call-btn--test call-hold")}
      onClick={onToggle}
      aria-pressed={held}
      title={held ? "Микрофон снова включится, музыка выключится" : "Собеседник услышит музыку, ваш микрофон выключится"}
    >
      {held ? "Вернуться к разговору" : "Удержание"}
    </button>
  );
}

/** Что видно на удержании: кто что слышит и, спустя пару минут, напоминание
 * (только текст — звука окно не издаёт). */
export function HoldHint({ since }: { since: number | null }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (since === null) return;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [since]);
  if (since === null) return null;
  const reminder = holdReminder(since, now);
  return (
    <>
      <div className="icall-hint call-hold-hint" role="status">
        <Icon name="pause" size={13} strokeWidth={1.8} />
        На удержании: собеседник слышит музыку, ваш микрофон выключен.
      </div>
      {reminder && (
        <div className="call-warn call-hold-reminder" role="status">
          {reminder}
        </div>
      )}
    </>
  );
}
